export class ChangePasswordModel{
	otp:number;
	userId:number;
	mobileNo:string;
	oldPassword:string;
	newPassword:string;
}